/**
 * Versionierter localStorage-Wrapper.
 *
 * - Ein Migrations-Lauf beim App-Start (in `migrate()`)
 * - Kapselt JSON.stringify/parse + try/catch
 * - Wenn neuer LS_VERSION_TARGET hochzählen + Migrations-Step ergänzen
 */

const VERSION_KEY = 'chat_ls_version';
const VERSION_TARGET = 2;

export const Keys = {
  TOKEN:    'chat_token',
  MODEL:    'chat_model',
  TEMP:     'chat_temperature',
  TMPL:     'chat_template',
  THEME:    'chat_theme',
  CHAT_ID:  'chat_current_id',
};

export function migrate() {
  try {
    const v = parseInt(localStorage.getItem(VERSION_KEY) || '0', 10);
    if (v >= VERSION_TARGET) return;
    if (v < 2) {
      // v1 → v2: Server-side Chat-History übernommen, lokaler Cache obsolet
      localStorage.removeItem('chat_messages');
    }
    localStorage.setItem(VERSION_KEY, String(VERSION_TARGET));
  } catch { /* never throws */ }
}

export function get(key, fallback = null) {
  try {
    const raw = localStorage.getItem(key);
    if (raw == null) return fallback;
    // Heuristik: JSON-String → parsen, sonst raw zurück
    if (raw.startsWith('{') || raw.startsWith('[') || raw === 'true' || raw === 'false' || raw === 'null') {
      return JSON.parse(raw);
    }
    return raw;
  } catch { return fallback; }
}

export function set(key, value) {
  try {
    if (value == null) {
      localStorage.removeItem(key);
      return;
    }
    if (typeof value === 'string') {
      localStorage.setItem(key, value);
    } else {
      localStorage.setItem(key, JSON.stringify(value));
    }
  } catch { /* quota / privacy mode */ }
}

export function remove(key) {
  try { localStorage.removeItem(key); } catch { /* ignore */ }
}
